import { SharedModule } from './../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CmsRoutingModule } from './cms-routing.module';
import { HomeComponent } from './home/home.component';
import { ContactComponent } from './contact/contact.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AlertModule,AlertConfig } from 'ngx-bootstrap/alert';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { FormsModule } from '@angular/forms';
import { SliderComponent } from './home/slider/slider.component';
import { ManagementComponent } from './management/management.component';
import { StaffComponent } from './staff/staff.component';
import { BranchesComponent } from './branches/branches.component';
import { ServicesComponent } from './services/services.component';
import { DepositComponent } from './deposit/deposit.component';
import { LoanComponent } from './loan/loan.component';
import { NewsComponent } from './news/news.component';
import { SuggestionComplaintComponent } from './suggestion-complaint/suggestion-complaint.component';
import { ReportComponent } from './report/report.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { TeamComponent } from './home/team/team.component';
import { GalleryComponent } from './gallery/gallery.component';
import { AnnualReportComponent } from './annual-report/annual-report.component';
import { MarqueeSectionComponent } from './home/marquee-section/marquee-section.component';
import { BranchAddressComponent } from './branch-address/branch-address.component';
import { MilestoneComponent } from './home/milestone/milestone.component';
import { AtmFacilityComponent } from './atm-facility/atm-facility.component';


@NgModule({
  declarations: [
    HomeComponent,
    ContactComponent,
    AboutUsComponent,
    PageNotFoundComponent,
    SliderComponent,
    ManagementComponent,
    StaffComponent,
    BranchesComponent,
    ServicesComponent,
    DepositComponent,
    LoanComponent,
    NewsComponent,
    SuggestionComplaintComponent,
    ReportComponent,
    FeedbackComponent,
    TeamComponent,
    TeamComponent,
    GalleryComponent,
    AnnualReportComponent,
    MarqueeSectionComponent,
    BranchAddressComponent,
    MilestoneComponent,
    AtmFacilityComponent
  ],
  imports: [
    CommonModule,
    CmsRoutingModule,
    AccordionModule,
    AlertModule,
    ButtonsModule,
    FormsModule,
    SharedModule
  ],
  exports :[
    SliderComponent,
    TeamComponent,
    SharedModule,
    MarqueeSectionComponent,
    BranchAddressComponent,
    MilestoneComponent
  ],
  providers: [AlertConfig],

})
export class CmsModule { }
